export default __webpack_public_path__ + "images/favicon/4 СМЕТА_.jpg";